var XPortal = XPortal || {};

XPortal.AIAssistant = (function () {

    var widgets = [];
    var STORAGE_KEY = 'xp_ai_thread_';

    var self = {
        selector: '.ai-assistant-widget',
        Init: function (container) {
            container = container ? $(container) : $("body");
            container.find(self.selector).each(function (xi, xe) {
                self.InitFor($(xe));
            });
        },
        InitFor: function ($widget) {
            if (!$widget.length) return;

            var sttgsStr = $widget.attr("data-sttgs");
            $widget.attr("data-sttgs", "");
            if (!sttgsStr) return;

            var sttgs = JSON.parse(sttgsStr);

            var memberId = sttgs.memberId || '';
            var wg = {
                id: $widget.attr("id"),
                el: $widget,
                sttgs: sttgs,
                agentAlias: sttgs.agentAlias,
                memberId: memberId,
                $panel: $widget.find('.ai-assistant-panel'),
                $history: $widget.find('.ai-assistant-panel__history'),
                $threadList: $widget.find('.ai-thread-list'),
                $messages: $widget.find('.ai-assistant-panel__messages'),
                $input: $widget.find('.ai-assistant-input'),
                $sendBtn: $widget.find('.ai-assistant-send-btn'),
                threadId: sessionStorage.getItem(STORAGE_KEY + memberId + '_' + sttgs.agentAlias) || null,
                threads: [],
                isStreaming: false,
                profileSent: false,
                threadTokens: {}   // { [threadId]: lastInputTokens } — for delta display
            };

            // Keep Bootstrap modal focus trap from stealing focus from the widget
            $widget.on('focusin', function (e) { e.stopPropagation(); });

            widgets.push(wg);
            loadThreadHistory(wg);
        }
    };

    // -------------------------------------------------------------------------
    // Panel
    // -------------------------------------------------------------------------

    function togglePanel(wg) {
        if (wg.$panel.is(':visible')) closePanel(wg);
        else openPanel(wg);
    }

    function openPanel(wg) {
        wg.$panel.css('display', 'flex');
        wg.$panel.addClass('is-open');

        wg.el.find('.ai-assistant-toggle-btn').addClass('is-open');
        if (!wg.$messages.children('.ai-message').length) {
            renderGreeting(wg);
        }
        wg.$input.trigger('focus');
        scrollToBottom(wg);

        initPanelResize(wg.$panel[0]);
    }

    function closePanel(wg) {
        wg.$panel.removeClass('is-open');

        wg.$panel.one('transitionend', function () {
            wg.$panel.css('display', 'none');
        });

        wg.el.find('.ai-assistant-toggle-btn').removeClass('is-open');
    }

    function newChat(wg) {
        wg.threadId = null;
        wg.threadTokens = {};
        sessionStorage.removeItem(STORAGE_KEY + wg.memberId + '_' + wg.agentAlias);
        closeHistory(wg);
        wg.$messages.empty();
        renderGreeting(wg);
        wg.$input.val('').trigger('input').trigger('focus');
    }

    // -------------------------------------------------------------------------
    // Thread history
    // -------------------------------------------------------------------------

    function threadStorageKey(wg) {
        return STORAGE_KEY + wg.memberId + '_' + wg.agentAlias;
    }

    function loadThreadHistory(wg) {
        if (!wg.sttgs.urls.threads) return;
        $.ajax({
            url: wg.sttgs.urls.threads + '?agentAlias=' + encodeURIComponent(wg.agentAlias),
            type: 'GET',
            success: function (resp) {
                var threads = (resp.threads || resp.Threads) || [];
                wg.threads = threads;
                // Restore latest thread from sessionStorage or first available thread
                if (!wg.threadId && threads.length > 0) {
                    var tid = threads[0].threadId || threads[0].ThreadId;
                    if (tid) {
                        wg.threadId = tid;
                        sessionStorage.setItem(threadStorageKey(wg), wg.threadId);
                    }
                }
                renderThreadList(wg);
                // Load last conversation messages on startup
                if (wg.threadId && wg.sttgs.urls.threadMessages) {
                    loadAndRenderThreadMessages(wg, wg.threadId);
                }
            }
        });
    }

    function renderThreadList(wg) {
        wg.$threadList.empty();
        if (!wg.threads || !wg.threads.length) {
            wg.el.find('.ai-assistant-history-btn').hide();
            return;
        }
        wg.el.find('.ai-assistant-history-btn').show();
        $.each(wg.threads, function (i, t) {
            var tid = t.threadId || t.ThreadId || '';
            var preview = t.preview || t.Preview || tid;
            var activity = t.lastActivity || t.LastActivity || '';
            var dateLabel = activity ? formatThreadDate(activity) : '';
            var isActive = tid === wg.threadId;
            var $item = $('<div class="ai-thread-item' + (isActive ? ' is-active' : '') + '"><i class="icon-history"></i></div>');
            $item.attr('data-tid', tid);
            var $info = $('<div class="ai-thread-item__info"></div>');
            $info.append('<span class="ai-thread-item__preview"></span>');
            $info.append('<span class="ai-thread-item__date"></span>');
            $item.append($info);
            $item.append('<span class="ai-thread-item__button"></span>');
            $item.find('.ai-thread-item__preview').text(preview);
            $item.find('.ai-thread-item__date').text(dateLabel);
            wg.$threadList.append($item);
        });
    }

    function formatThreadDate(iso) {
        try {
            var d = new Date(iso);
            if (isNaN(d)) return iso;
            var now = new Date();
            var diffMs = now - d;
            var diffDays = Math.floor(diffMs / 86400000);
            if (diffDays === 0) return d.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' });
            if (diffDays === 1) return 'Yesterday';
            if (diffDays < 7) return diffDays + 'd ago';
            return d.toLocaleDateString([], { month: 'short', day: 'numeric' });
        } catch (e) { return ''; }
    }

    function toggleHistory(wg) {
        if (wg.$history.is(':visible')) closeHistory(wg);
        else openHistory(wg);
    }

    function openHistory(wg) {
        wg.$history.slideDown(150);
        wg.el.find('.ai-assistant-history-btn').addClass('is-active is-active-hide').attr('aria-expanded', 'true');
        wg.el.find('.ai-assistant-panel__title').html(`
            <button class="ai-assistant-btn ai-assistant-history-btn" type="button" aria-expanded="false">
                    <i class="icon-arrow-left"></i>
                </button>
            History
        `);
        wg.el.find('.ai-assistant-new-chat-btn').hide();
    }

    function closeHistory(wg) {
        wg.$history.slideUp(150);
        wg.el.find('.ai-assistant-history-btn').removeClass('is-active is-active-hide').attr('aria-expanded', 'false');
        wg.el.find('.ai-assistant-panel__title').html(`
            <i class="icon-chat-3"></i>
            AI Assistant
        `);
        wg.el.find('.ai-assistant-history-btn').show();
        wg.el.find('.ai-assistant-new-chat-btn').show();
    }

    function switchThread(wg, threadId) {
        if (wg.isStreaming) return;
        wg.threadId = threadId;
        sessionStorage.setItem(threadStorageKey(wg), wg.threadId);
        closeHistory(wg);
        wg.$messages.empty();
        wg.$threadList.find('.ai-thread-item').each(function () {
            $(this).toggleClass('is-active', $(this).data('tid') === threadId);
        });

        if (wg.sttgs.urls.threadMessages) {
            loadAndRenderThreadMessages(wg, threadId);
        } else {
            appendSystemMessage(wg.sttgs.msgs.resumed || 'Conversation resumed.', wg);
        }
        wg.$input.trigger('focus');
    }

    function loadAndRenderThreadMessages(wg, threadId) {
        $.ajax({
            url: wg.sttgs.urls.threadMessages + '?threadId=' + encodeURIComponent(threadId),
            type: 'GET',
            success: function (resp) {
                var messages = (resp.messages || resp.Messages) || [];
                if (messages.length > 0) {
                    renderThreadMessages(wg, messages);
                } else {
                    appendSystemMessage(wg.sttgs.msgs.resumed || 'Conversation resumed.', wg);
                }
            },
            error: function () {
                appendSystemMessage(wg.sttgs.msgs.resumed || 'Conversation resumed.', wg);
            }
        });
    }

    function renderThreadMessages(wg, messages) {
        $.each(messages, function (i, m) {
            var userText = m.userMessage || m.UserMessage || '';
            var aiText = m.aiResponse || m.AiResponse || '';
            var blocked = m.isBlocked || m.IsBlocked || false;

            if (userText) appendUserMessage(userText, wg);

            if (blocked) {
                appendErrorMessage(wg.sttgs.msgs.error || 'Something went wrong.', wg);
            } else if (aiText) {
                appendAiMessageHtml(aiText, wg);
            }
        });
        scrollToBottom(wg);
    }

    // -------------------------------------------------------------------------
    // Messaging
    // -------------------------------------------------------------------------

    function sendMessage(wg) {
        var text = wg.$input.val().trim();
        if (!text || wg.isStreaming) return;

        appendUserMessage(text, wg);
        wg.$input.val('').trigger('input');
        autoResize(wg.$input[0]);
        setStreaming(true, wg);

        var $typingEl = appendTypingIndicator(wg);
        streamMessage(wg, text, $typingEl);
    }

    var MAX_SSE_RETRIES = 3;

    function streamMessage(wg, text, $typingEl) {
        ensureThread(wg, function (tid, isNew) {
            wg.threadId = tid;
            sessionStorage.setItem(STORAGE_KEY + wg.memberId + '_' + wg.agentAlias, wg.threadId);

            var sendProfile = isNew || !wg.profileSent;
            wg.profileSent = true;

            var $bubble = null;
            var textBuffer = '';
            var retryCount = 0;
            var logId = null;
            var pendingUsage = null;

            function connectSSE() {
                var params = new URLSearchParams({
                    agentAlias: wg.agentAlias,
                    threadId: wg.threadId,
                    message: text,
                    pagePath: window.location.pathname,
                    isNew: sendProfile ? 'true' : 'false'
                });

                var evtSource = new EventSource(wg.sttgs.urls.stream + '?' + params.toString());
                var receivedData = false;

                evtSource.onmessage = function (e) {
                    receivedData = true;
                    var data = e.data;

                    if (data === '[DONE]') {
                        evtSource.close();
                        $typingEl.remove();
                        if (!$bubble && textBuffer) {
                            $bubble = appendAiMessageHtml(textBuffer, wg);
                        } else if ($bubble && textBuffer) {
                            // Final render without balanceHtml — the response is complete
                            $bubble.find('.ai-message__text').html(renderMessageContent(textBuffer, wg));
                        }
                        setStreaming(false, wg);
                        if ($bubble && pendingUsage) appendUsageInfo($bubble, pendingUsage, wg);
                        if ($bubble) processAiRenderTags($bubble, wg, logId);
                        scrollToBottom(wg);
                        return;
                    }

                    try {
                        var parsed = JSON.parse(data);

                        if (parsed.threadId) {
                            wg.threadId = parsed.threadId;
                            sessionStorage.setItem(STORAGE_KEY + wg.memberId + '_' + wg.agentAlias, wg.threadId);
                            loadThreadHistory(wg);
                            return;
                        }

                        if (parsed.error) {
                            evtSource.close();
                            $typingEl.remove();
                            if (parsed.error === 'limit') appendWarningMessage(wg.sttgs.msgs.limit || parsed.message, wg);
                            else appendErrorMessage(wg.sttgs.msgs.error, wg);
                            setStreaming(false, wg);
                            return;
                        }

                        if (parsed.usage) {
                            if (parsed.usage.logId) logId = parsed.usage.logId;
                            pendingUsage = parsed.usage;
                            return;
                        }

                        if (parsed.text !== undefined) {
                            textBuffer += parsed.text;
                            if (!$bubble) {
                                $typingEl.remove();
                                $bubble = appendAiMessageHtml('', wg);
                            }
                            $bubble.find('.ai-message__text').html(balanceHtml(renderMessageContent(textBuffer, wg)));
                            scrollToBottom(wg);
                        }
                    } catch (ex) {
                        // non-JSON SSE chunk — ignore
                    }
                };

                evtSource.onerror = function () {
                    evtSource.close();
                    if (!receivedData && retryCount < MAX_SSE_RETRIES) {
                        retryCount++;
                        setTimeout(connectSSE, 1000 * retryCount);
                        return;
                    }
                    $typingEl.remove();
                    if (!$bubble) appendErrorMessage(wg.sttgs.msgs.error, wg);
                    setStreaming(false, wg);
                };
            }

            connectSSE();
        });
    }

    function appendUsageInfo($bubble, usage, wg) {
        if (!$bubble) return;
        var u = usage;
        var prevIn = wg.threadTokens[wg.threadId];
        var dur = u.durationMs >= 1000
            ? (u.durationMs / 1000).toFixed(1) + 's'
            : u.durationMs + 'ms';
        var modelName = (u.model || '').replace(/\s+v[\d.]+$/, '');
        var prefix = u.estimated ? '~' : '';
        var total = prefix + '\u03a3' + fmtTok(u.totalTokens);
        var now = new Date();
        var h = now.getHours();
        var ampm = h >= 12 ? 'PM' : 'AM';
        h = h % 12 || 12;
        var time = ('0' + h).slice(-2) + ':' + ('0' + now.getMinutes()).slice(-2) + ' ' + ampm;
        var parts = [time, dur];
        if (modelName) parts.push(modelName);
        parts.push(total);
        if (u.remainingRequests != null) parts.push(u.remainingRequests + ' ' + (wg.sttgs.msgs.left || 'messages left'));
        var inDisplay = (prevIn > 0 && u.inputTokens > prevIn)
            ? fmtTok(prevIn) + '+' + fmtTok(u.inputTokens - prevIn)
            : fmtTok(u.inputTokens);
        var tooltip = '\u2191' + inDisplay + ' \u2193' + fmtTok(u.outputTokens);
        if (u.cachedTokens > 0) tooltip += ' \uD83D\uDCBE' + fmtTok(u.cachedTokens);
        if (u.reasoningTokens > 0) tooltip += ' \uD83E\uDDE0' + fmtTok(u.reasoningTokens);
        $bubble.find('.ai-message__text').append(
            '<div class="ai-message__tokens" title="' + tooltip + '">' + parts.join(' \u00b7 ') + '</div>'
        );
        wg.threadTokens[wg.threadId] = u.inputTokens;
    }

    function ensureThread(wg, callback) {
        if (wg.threadId) {
            callback(wg.threadId, false);
            return;
        }
        $.ajax({
            url: wg.sttgs.urls.thread,
            type: 'POST',
            contentType: 'application/json',
            headers: { 'RequestVerificationToken': XPortal.Main.getAntiForgeryToken() },
            data: JSON.stringify({ agentAlias: wg.agentAlias }),
            success: function (resp) { callback(resp.threadId || resp.ThreadId, true); },
            error: function () { appendErrorMessage(wg.sttgs.msgs.error, wg); setStreaming(false, wg); }
        });
    }

    // -------------------------------------------------------------------------
    // DOM helpers
    // -------------------------------------------------------------------------

    function renderGreeting(wg) {
        if (wg.sttgs.msgs.greeting) appendAiMessage(wg.sttgs.msgs.greeting, wg);
    }

    function appendUserMessage(text, wg) {
        var $msg = $('<div class="ai-message ai-message--user"><div class="ai-message__text"></div></div>');
        $msg.find('.ai-message__text').text(text);
        wg.$messages.append($msg);
        scrollToBottom(wg);
        return $msg;
    }

    function appendAiMessage(text, wg) {
        var $msg = $('<div class="ai-message ai-message--ai"><span class="ai-message__avatar"></span><div class="ai-message__text"></div></div>');
        $msg.find('.ai-message__text').text(text);
        wg.$messages.append($msg);
        scrollToBottom(wg);
        return $msg;
    }

    function renderMessageContent(html, wg) {
        var thinkRe = /<think>([\s\S]*?)<\/think>/i;
        var thinkOpenRe = /<think>/i;

        if (!wg.sttgs.devMode) {
            return html.replace(thinkRe, '').replace(thinkOpenRe, '').trim();
        }

        var match = thinkRe.exec(html);
        var hasOpenTag = thinkOpenRe.test(html);

        if (!match && !hasOpenTag) return html;

        var thinkContent, mainContent, isComplete;
        if (match) {
            thinkContent = match[1];
            mainContent = html.replace(thinkRe, '').trim();
            isComplete = true;
        } else {
            thinkContent = html.replace(thinkOpenRe, '');
            mainContent = '';
            isComplete = false;
        }

        var thinkBlock = '<details class="ai-thinking"' + (isComplete ? '' : ' open') + '>'
            + '<summary>' + (wg.sttgs.msgs.thinking || 'Thinking') + '</summary>'
            + '<div class="ai-thinking__body">' + thinkContent + '</div>'
            + '</details>';

        return mainContent + thinkBlock;
    }

    function processAiRenderTags($bubble, wg, logId) {
        var promises = [];
        $bubble.find('ai-render').each(function () {
            var $tag = $(this);
            var renderId = $tag.attr('id') || '';
            var fieldTitles = {};
            ($tag.attr('field-titles') || '').split(',').forEach(function (ft) {
                var idx = ft.indexOf(':');
                if (idx > 0) fieldTitles[ft.substring(0, idx).trim()] = ft.substring(idx + 1).trim();
            });

            $tag.addClass('ai-render--loading');

            var deferred = $.ajax({
                url: wg.sttgs.urls.renderItems,
                type: 'POST',
                contentType: 'application/json',
                headers: { 'RequestVerificationToken': XPortal.Main.getAntiForgeryToken() },
                data: JSON.stringify({ threadId: wg.threadId, renderId: renderId, fieldTitles: fieldTitles, LCID: wg.sttgs.culture }),
                success: function (res) {
                    if (!res || !res.items || !res.template) { $tag.remove(); return; }
                    var formatMap = buildFormatMap(res.format);
                    var html = res.items.map(function (iitem) {
                        var item = XPortal.Grid.MapEntity(iitem.item, {});
                        item.url = iitem.url;
                        return renderItemFromTemplate(item, res.template, fieldTitles, renderId, formatMap.map, res.id);
                    }).join('');
                    $tag.replaceWith('<ul class="ai-results">' + html + '</ul>');
                    scrollToBottom(wg);
                },
                error: function () { $tag.remove(); }
            });
            promises.push(deferred);
        });

        if (promises.length > 0) {
            $.when.apply($, promises).always(function () {
                saveRenderedResponse(wg, $bubble, logId);
            });
        }
    }

    function saveRenderedResponse(wg, $bubble, logId) {
        if (!logId || !wg.sttgs.urls.saveRendered) return;
        var html = $bubble.find('.ai-message__text').html();
        if (!html) return;
        $.ajax({
            url: wg.sttgs.urls.saveRendered,
            type: 'POST',
            contentType: 'application/json',
            headers: { 'RequestVerificationToken': XPortal.Main.getAntiForgeryToken() },
            data: JSON.stringify({ logId: logId, html: html })
        });
    }

    function buildFormatMap(formatArr) {
        var maps = {};
        var flds = [];
        if (!formatArr) return maps;
        formatArr.forEach(function (f) {
            if (f.fdn) {
                maps[f.fdn] = f;                
                flds.push({ Name: f.fdn, Type: f.fdt.split('|')[0] });
            }
        });
        return { map: maps, fields: flds };
    }

    function renderItemFromTemplate(item, template, fieldTitles, setupId, formatMap, nodeId) {
        var html = template;
        html = html.replace(/\[\[url\]\]/gi, item.url || '#');
        html = html.replace(/\[\[id\]\]/gi, item.id || '');
        html = html.replace(/\[\[([^\]|]+)\|title\]\]/gi, function (_, name) {
            return fieldTitles[name] || name;
        });
        for (var i = 0; i < item.Fields.length; i++) {
            var field = item.Fields[i];
            var key = field.Name;
            var val = XPortal.Template.GetObjPropValueByName(item, key);
            val = formatFieldValue(val, field, item, setupId, formatMap, nodeId);
            html = html.replace(
                new RegExp('\\[\\[' + key.replace(/[.*+?^${}()|[\]\\]/g, '\\$&') + '\\]\\]', 'gi'),
                val
            );
        }
        html = XPortal.Format.ProcessTemplate(html, '', item, setupId);
        var xhtml = $("<div><!----></div>");
        xhtml.html(html);
        hideEmptyFields(xhtml);
        return xhtml.html();
    }

    function formatFieldValue(val, field, item, setupId, formatMap, nodeId) {
        var fieldName = field.Name;
        var fmt = !formatMap ? false : formatMap[fieldName.toLowerCase()];
        if (!fmt) return val;
        if (fmt.exf && fmt.exf.Method) {
            try {
                var fn = new Function('data', 'type', 'field', 'inFormat', 'nodeid', 'htmlTemplate', 'fopts',
                    'return ' + fmt.exf.Method + '(data, type, field, inFormat, nodeid, htmlTemplate, fopts);');
                var fdt = (fmt.fdt || '').split('|')[0] || 'string';
                fmt.exf.formatExtended = fmt.exf;
                fmt.exf.modelName = 'ai.gen.msg';

                var result = fn(item.fields || item, fdt, fieldName, null, nodeId, fmt.exf.TemplateName, fmt.exf);
                return result || val;
            } catch (e) {
                if (console) console.log('AI formatFieldValue extended error', e);
            }
        }
        if (isImageEditor(fmt.edr, field.Type) && val) {
            return buildImageTag(val, item, nodeId, fieldName);
        }
        if (isBase64(fmt.edr, field.Type))
            return buildFieldLink(val, item, nodeId, fieldName);
        return val;
    }

    function isImageEditor(editorName, fiedlType)
    {        
        return editorName && editorName.toLowerCase().indexOf('image') >= 0;
    }
    function isBase64(editorName, fiedlType) {
        return fiedlType && fiedlType.toLowerCase().indexOf('base64') >= 0;
    }
    function buildImageTag(val, item, nodeId, fieldName) {
        var file = [{ uid: val, name: val, dst: val, existing: '1' }];
        var entityUid = item.uniqueid || '';
        var alias = item.alias || ( (item.fields || {}).Alias || '');
        var src = XPortal.UploadFiles.GetDirectLink(file, entityUid, alias, nodeId, fieldName);
        return '<img src="' + src + '" alt="" class="ai-render-image" />';
    }
    function buildFieldLink(val, item, nodeId, fieldName) {
        var file = [{ uid: val, name: val, dst: val, existing: '1' }];
        var entityUid = item.uniqueid || '';
        var alias = item.alias || ((item.fields || {}).Alias || '');
        var src = XPortal.UploadFiles.GetDirectLink(file, entityUid, alias, nodeId, fieldName);
        return '<a href="' + src + '" alt="" class="ai-render-file" >'+val+'</a>';
    } 

    function hideEmptyFields(container) {
        var xhtml = $(container);
        xhtml.find(".fld_").each(function (xi, x) {
            var $fldv = $(x).find(".fldv");
            var hasText = ($fldv.text() || '').trim().length > 0;
            var hasHtml = $fldv.find('img, svg, canvas, [class*="ex-format"]').length > 0;
            if (!hasText && !hasHtml)
                $(x).remove();
        });
        xhtml.find('a').each(function () {
            var href = ($(this).attr('href') || '').trim();
            if (!href || href === '#')
                $(this).hide();
        });
    }

    function appendAiMessageHtml(html, wg) {
        var $msg = $('<div class="ai-message ai-message--ai"><span class="ai-message__avatar"></span><div class="ai-message__text ai-message__text--html"></div></div>');
        $msg.find('.ai-message__text').html(renderMessageContent(html, wg));
        wg.$messages.append($msg);
        hideEmptyFields(wg.$messages);
        scrollToBottom(wg);
        return $msg;
    }

    function appendTypingIndicator(wg) {
        var $el = $('<div class="ai-message ai-message--ai ai-message--typing"><span class="ai-message__avatar"></span><div class="ai-typing"><span></span><span></span><span></span></div></div>');
        wg.$messages.append($el);
        scrollToBottom(wg);
        return $el;
    }

    function appendErrorMessage(text, wg) {
        var $msg = $('<div class="ai-message ai-message--error"><div class="ai-message__icon"><i class="icon-error-warning"></i></div><div class="ai-message__text"></div></div>');
        $msg.find('.ai-message__text').text(text);
        wg.$messages.append($msg);
        scrollToBottom(wg);
    }

    function appendWarningMessage(text, wg) {
        var $msg = $('<div class="ai-message ai-message--warning"><div class="ai-message__icon"><i class="icon-alarm-warning"></i></div><div class="ai-message__text"></div></div>');
        $msg.find('.ai-message__text').text(text);
        wg.$messages.append($msg);
        scrollToBottom(wg);
    }

    function appendSystemMessage(text, wg) {
        var $msg = $('<div class="ai-message ai-message--system"><div class="ai-message__text"></div></div>');
        $msg.find('.ai-message__text').text(text);
        wg.$messages.append($msg);
        scrollToBottom(wg);
    }

    function fmtTok(n) {
        if (n >= 1000000) return (n / 1000000).toFixed(n % 1000000 === 0 ? 0 : 1) + 'M';
        if (n >= 10000) return Math.round(n / 1000) + 'K';
        if (n >= 1000) return (n / 1000).toFixed(1) + 'K';
        return String(n);
    }

    // Temporarily close open HTML tags so innerHTML renders correctly during streaming.
    // On the next chunk the buffer grows and is re-balanced from scratch.
    function balanceHtml(html) {
        var voidTags = /^(area|base|br|col|embed|hr|img|input|link|meta|param|source|track|wbr)$/i;
        var tagRe = /<\/?([a-zA-Z][a-zA-Z0-9]*)\b[^>]*\/?>/g;
        var stack = [];
        var m;
        while ((m = tagRe.exec(html)) !== null) {
            var full = m[0], name = m[1].toLowerCase();
            if (voidTags.test(name) || full.charAt(full.length - 2) === '/') continue;
            if (full.charAt(1) === '/') {
                for (var i = stack.length - 1; i >= 0; i--) {
                    if (stack[i] === name) { stack.splice(i, 1); break; }
                }
            } else {
                stack.push(name);
            }
        }
        for (var i = stack.length - 1; i >= 0; i--) html += '</' + stack[i] + '>';
        return html;
    }

    function scrollToBottom(wg) {
        wg.$messages.scrollTop(wg.$messages[0].scrollHeight);
    }

    function autoResize(el) {
        el.style.height = 'auto';
        el.style.height = Math.min(el.scrollHeight, 120) + 'px';
    }

    function setStreaming(val, wg) {
        wg.isStreaming = val;
        var hasText = wg.$input.val().trim().length > 0;
        wg.$sendBtn.prop('disabled', !hasText || wg.isStreaming);
        wg.el.find('.ai-assistant-new-chat-btn').prop('disabled', val);
    }

    function getWidget(el) {
        var $widget = el.closest(self.selector);
        if (!$widget.length) return null;
        var id = $widget.attr("id");
        return widgets.find(function (w) { return w.id === id; }) || null;
    }

    // -------------------------------------------------------------------------
    // Event bindings
    // -------------------------------------------------------------------------

    $(document).on("click", ".ai-assistant-toggle-btn", function () {
        var wg = getWidget($(this));
        if (!wg) return;
        togglePanel(wg);
    });

    $(document).on("click", ".ai-assistant-close-btn", function () {
        var wg = getWidget($(this));
        if (!wg) return;
        closePanel(wg);
    });

    $(document).on("click", ".ai-assistant-history-btn", function () {
        var wg = getWidget($(this));
        if (!wg) return;
        toggleHistory(wg);
    });

    $(document).on("click", ".ai-thread-item", function () {
        var $btn = $(this);
        var wg = getWidget($btn);
        if (!wg) return;
        var tid = $btn.data('tid');
        if (tid) switchThread(wg, tid);
    });

    $(document).on("click", ".ai-assistant-new-chat-btn", function () {
        var wg = getWidget($(this));
        if (!wg) return;
        newChat(wg);
    });

    $(document).on("click", ".ai-assistant-send-btn", function () {
        var wg = getWidget($(this));
        if (!wg) return;
        sendMessage(wg);
    });

    $(document).on("click", ".ai-suggestion", function () {
        var wg = getWidget($(this));
        if (!wg || wg.isStreaming) return;
        var msg = $(this).attr('data-msg') || $(this).text().trim();
        wg.$input.val(msg).trigger('input');
        sendMessage(wg);
    });

    $(document).on("click", ".ai-result-item", function () {
        var href = $(this).find('a').attr('href');
        if (href && href !== '#') window.location.href = href;
    });

    $(document).on("input", ".ai-assistant-input", function () {
        var wg = getWidget($(this));
        if (!wg) return;
        autoResize(this);
        var hasText = wg.$input.val().trim().length > 0;
        wg.$sendBtn.prop('disabled', !hasText || wg.isStreaming);
    });

    $(document).on("keydown", ".ai-assistant-input", function (e) {
        if (e.key === 'Enter' && !e.shiftKey) {
            e.preventDefault();
            var wg = getWidget($(this));
            if (!wg) return;
            sendMessage(wg);
        }
    });

    return self;

}());

function initPanelResize(panel) {
    if (!panel || panel._resizeInitialized) return;
    panel._resizeInitialized = true;

    var edges = ['top', 'left', 'top-left'];
    edges.forEach(function (edge) {
        var handle = document.createElement('div');
        handle.className = 'ai-resize-handle ai-resize-handle--' + edge;
        handle.setAttribute('data-edge', edge);
        panel.appendChild(handle);

        handle.addEventListener('mousedown', function (e) {
            e.preventDefault();
            startResize(e, panel, edge);
        });
    });
}

function startResize(e, panel, edge) {
    var startX = e.clientX;
    var startY = e.clientY;
    var startW = panel.offsetWidth;
    var startH = panel.offsetHeight;
    var startLeft = panel.offsetLeft;
    var startTop = panel.offsetTop;

    var MIN_W = 350, MIN_H = 275;

    function onMove(ev) {
        var dx = ev.clientX - startX;
        var dy = ev.clientY - startY;

        if (edge === 'top' || edge === 'top-left') {
            var newH = Math.max(MIN_H, startH - dy);
            panel.style.height = newH + 'px';
        }
        if (edge === 'left' || edge === 'top-left') {
            var newW = Math.max(MIN_W, startW - dx);
            panel.style.width = newW + 'px';
        }
    }

    function onUp() {
        document.removeEventListener('mousemove', onMove);
        document.removeEventListener('mouseup', onUp);
        document.body.style.userSelect = '';
        document.body.style.cursor = '';
    }

    document.body.style.userSelect = 'none';
    document.body.style.cursor = edge === 'top' ? 'n-resize' : edge === 'left' ? 'w-resize' : 'nw-resize';
    document.addEventListener('mousemove', onMove);
    document.addEventListener('mouseup', onUp);
}

$(function () { XPortal.AIAssistant.Init(); });